import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

// @param sessionData: object
// example:
// {
//   "student_id": 1,
//   "date": "nil",
//   "start_time": "10:15",
//   "end_time": "11:30",
//   "start_page_number": 30,
//   "end_page_number": 35,
//   "meeting_url": "https://linear.app/sanad/issue/SAN-153/endpoint-to-create-session" ,
//   "recording_url": "https://linear.app/sanad/issue/SAN-153/endpoint-to-create-session"

//  }
export function createTutorSession(sessionData: object): Promise<ApiResponse> {
  return Axios.post("v2/tutors/sessions", sessionData);
}

// @param sessionData: object
// example:
// {
//   "student_id": 1,
//   "date": "nil",
//   "start_time": "10:15",
//   "end_time": "11:30",
//   "start_page_number": 30,
//   "end_page_number": 35,
//   "meeting_url": "https://linear.app/sanad/issue/SAN-153/endpoint-to-create-session" ,
//   "recording_url": "https://linear.app/sanad/issue/SAN-153/endpoint-to-create-session"

//
export function updateTutorSession(
  id: string | number,
  sessionData: object
): Promise<ApiResponse> {
  return Axios.put(`v2/tutors/sessions/${id}`, sessionData);
}

export function indexTutorSessions(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v2/tutors/sessions", { params });
}

// end_time: "2000-01-01T05:00:00.000Z"
// id: "946699200_946702800"
// schedule_slot: {id: 9, created_at: "2022-04-17T04:50:09.616Z", day_of_the_week: "sunday",…}
// created_at: "2022-04-17T04:50:09.616Z"
// day_of_the_week: "sunday"
// end_time: "2000-01-01T05:00:00.000Z"
// id: 9
// object_type: "ScheduleSlot"
// start_time: "2000-01-01T04:00:00.000Z"
// updated_at: "2022-04-17T04:50:09.616Z"
// start_time: "2000-01-01T04:00:00.000Z"
// student: {id: 29, birth_date: null, city: null, country: null, created_at: "2022-04-15T21:26:40.437Z",…}
export function getTutorUpcomingSessions(): Promise<ApiResponse> {
  return Axios.get("/v2/tutors/sessions/upcoming");
}

export function getTutorInProgressSessions(): Promise<ApiResponse> {
  return Axios.get("/v2/tutors/sessions/in_progress");
}

export function showTutorSessions(
  sessionId: string | number,
  referrer?: string
): Promise<ApiResponse> {
  const params: { referrer?: string } = {};
  if (!!referrer) {
    params["referrer"] = referrer;
  }
  return Axios.get(`v2/tutors/sessions/${sessionId}`, { params });
}

export function createInstantSession(
  scheduleData: object
): Promise<ApiResponse> {
  return Axios.post("/v2/tutors/sessions/create_instant_session", scheduleData);
}

export function tutorCancelSession(slot: object): Promise<ApiResponse> {
  return Axios.post("/v1/tutors/cancellations", slot);
}
export function tutorCancelGroup(): Promise<ApiResponse> {
  return Axios.delete("/v1/tutors/schedules");
}
